/* Gymatics keyboard fit v1 (site-wide).
 * 1. theme.liquid's viewport meta uses interactive-widget=resizes-content, so on Android
 *    (Chrome, Samsung Internet) the page shrinks above the on-screen keyboard and fixed
 *    panels such as Buddy, dialogs and drawers sit above it.
 * 2. This script covers browsers that ignore that setting (iOS Safari, older Android):
 *    it publishes --gm-keyboard-inset / --gm-visible-height on <html>, adds
 *    html.gm-keyboard-open while typing, hides bottom-fixed bars that would cover the
 *    field, and scrolls a normal (non-fixed) field back into view if the keyboard hides it.
 */
(function () {
  'use strict';
  if (window.GymaticsKeyboard) return;
  var vv = window.visualViewport;
  var root = document.documentElement;
  var FIELD = 'input:not([type=button]):not([type=submit]):not([type=reset]):not([type=checkbox]):not([type=radio]):not([type=range]):not([type=hidden]):not([type=file]):not([type=color]),textarea,select,[contenteditable=""],[contenteditable="true"]';
  var active = null;
  var baseHeight = window.innerHeight;

  function isField(el) { return !!(el && el.nodeType === 1 && el.matches && el.matches(FIELD)); }
  function deepActive() { var a = document.activeElement; while (a && a.shadowRoot && a.shadowRoot.activeElement) a = a.shadowRoot.activeElement; return a; }
  // True when the field sits inside a position:fixed/sticky container (Buddy, dialogs, drawers).
  // Those manage their own fit; scrolling the page would only make it jump.
  function inFixed(el) {
    var n = el;
    while (n && n !== document.documentElement) {
      if (n.nodeType === 1) {
        var p = getComputedStyle(n).position;
        if (p === 'fixed' || p === 'sticky') return true;
        if (n.tagName === 'DIALOG' && n.open) return true;
      }
      n = n.parentNode || n.host;
    }
    return false;
  }

  function update() {
    // Focus moving inside a shadow root (e.g. Buddy) doesn't reach document focusin, so re-check here.
    var a = deepActive(); if (isField(a)) active = a;
    var vh = vv ? vv.height : window.innerHeight;
    var top = vv ? vv.offsetTop : 0;
    var inset = Math.max(0, Math.round(window.innerHeight - vh - top));
    root.style.setProperty('--gm-keyboard-inset', inset + 'px');
    root.style.setProperty('--gm-visible-height', Math.round(vh) + 'px');
    root.style.setProperty('--gm-visible-top', Math.round(top) + 'px');
    // Open when the visual viewport is covered (iOS / resizes-visual) or the layout
    // viewport shrank while a field is focused (Android / resizes-content).
    var open = !!active && (inset > 120 || window.innerHeight < baseHeight - 120);
    root.classList.toggle('gm-keyboard-open', open);
  }

  function reveal() {
    if (!active || !active.isConnected || inFixed(active)) return;
    var r = active.getBoundingClientRect();
    var top = vv ? vv.offsetTop : 0;
    var bottom = top + (vv ? vv.height : window.innerHeight);
    if (r.bottom > bottom - 16 || r.top < top + 8) {
      try { active.scrollIntoView({ block: 'center', inline: 'nearest' }); } catch (_) { active.scrollIntoView(); }
    }
  }

  document.addEventListener('focusin', function (e) {
    var el = (e.composedPath && e.composedPath()[0]) || e.target;
    if (!isField(el)) return;
    if (!active) baseHeight = Math.max(baseHeight, window.innerHeight);
    active = el;
    update();
    setTimeout(function () { update(); reveal(); }, 350);
    setTimeout(function () { update(); reveal(); }, 750);
  }, true);

  document.addEventListener('focusout', function () {
    setTimeout(function () {
      var a = deepActive();
      active = isField(a) ? a : null;
      if (!active) baseHeight = Math.max(baseHeight, window.innerHeight);
      update();
    }, 60);
  }, true);

  if (vv) {
    vv.addEventListener('resize', function () { update(); reveal(); }, { passive: true });
    vv.addEventListener('scroll', update, { passive: true });
  }
  window.addEventListener('resize', update, { passive: true });
  window.addEventListener('orientationchange', function () { active = null; setTimeout(function () { baseHeight = window.innerHeight; update(); }, 400); });

  // Bottom-fixed bars ride up with the keyboard and cover the field being typed in: hide them while typing.
  var css = document.createElement('style');
  css.id = 'gymatics-keyboard-css';
  css.textContent =
    'html.gm-keyboard-open .sticky-atc-bar,' +
    'html.gm-keyboard-open .compare-banner,' +
    'html.gm-keyboard-open .scroll-to-top,' +
    'html.gm-keyboard-open .gymatics-page-dock__bar,' +
    'html.gm-keyboard-open #BuddyRestore,' +
    'html.gm-keyboard-open [data-buddy-version][data-open="false"]' +
    '{display:none!important}' +
    // Dialogs (e.g. Talk to Gymatics) fit the visible area and scroll inside.
    'html.gm-keyboard-open dialog[open]{top:calc(var(--gm-visible-top,0px) + 8px)!important;bottom:auto!important;margin-top:0!important;max-height:calc(var(--gm-visible-height,100dvh) - 16px)!important;overflow:auto!important}';
  (document.head || root).appendChild(css);

  update();
  window.GymaticsKeyboard = Object.freeze({ version: '1.0.0', update: update });
})();
